import React from 'react'
import {
  LuCheck,
  LuHeart,
  LuMapPin,
  LuMessageCircle,
  LuMusic2,
  LuSparkles,
  LuVolume2,
} from 'react-icons/lu'

const PrincipleMotion = ({ type, icon: Icon }) => (
  <div className={`tips-principle-visual tips-principle-visual--${type}`} aria-hidden="true">
    <span className="tips-insight-grid" />
    <span className="tips-insight-scan" />

    {type === 'attrition' && (
      <div className="tips-principle-motion tips-principle-motion--attrition">
        <span className="tips-principle-motion__core"><Icon /></span>
        <i className="tips-principle-motion__trace tips-principle-motion__trace--one" />
        <i className="tips-principle-motion__trace tips-principle-motion__trace--two" />
        <i className="tips-principle-motion__trace tips-principle-motion__trace--three" />
        <span className="tips-principle-motion__node tips-principle-motion__node--one" />
        <span className="tips-principle-motion__node tips-principle-motion__node--two" />
        <span className="tips-principle-motion__node tips-principle-motion__node--three" />
        <span className="tips-principle-motion__node tips-principle-motion__node--four" />
      </div>
    )}

    {type === 'recall' && (
      <div className="tips-principle-motion tips-principle-motion--recall">
        <span className="tips-recall-node tips-recall-node--prompt">?</span>
        <i className="tips-recall-route tips-recall-route--in" />
        <span className="tips-recall-core">
          <i />
          <Icon />
        </span>
        <i className="tips-recall-route tips-recall-route--out" />
        <span className="tips-recall-node tips-recall-node--answer"><LuCheck /></span>
      </div>
    )}

    {type === 'spacing' && (
      <div className="tips-principle-motion tips-principle-motion--spacing">
        <span className="tips-spacing-icon"><Icon /></span>
        <div className="tips-spacing-line">
          {[1, 3, 7, 14].map((day, index) => (
            <span key={day} style={{ '--spacing-index': index }}>
              <i />
              <span><span lang="fr">J{day}</span><small lang="en">D{day}</small></span>
            </span>
          ))}
          <b />
        </div>
      </div>
    )}

    {type === 'emotion' && (
      <div className="tips-principle-motion tips-principle-motion--emotion">
        <span className="tips-emotion-orbit tips-emotion-orbit--outer" />
        <span className="tips-emotion-orbit tips-emotion-orbit--inner" />
        <span className="tips-emotion-core"><Icon /></span>
        <span className="tips-emotion-cue tips-emotion-cue--music"><LuMusic2 /></span>
        <span className="tips-emotion-cue tips-emotion-cue--place"><LuMapPin /></span>
        <span className="tips-emotion-cue tips-emotion-cue--voice"><LuMessageCircle /></span>
      </div>
    )}

    <span className="tips-principle-visual__status">
      <i />
      <span lang="fr">signal mémoriel</span>
      <small lang="en">memory signal</small>
    </span>
  </div>
)

const VoiceBars = () => (
  <span className="tips-practice-wave">
    {[8, 17, 25, 13, 29, 19, 23, 11, 18].map((height, index) => (
      <i key={`${height}-${index}`} style={{ '--practice-wave-height': `${height}px`, '--practice-wave-index': index }} />
    ))}
  </span>
)

const PracticeMotion = ({ type, icon: Icon }) => (
  <div className={`tips-practice-visual tips-practice-visual--${type}`} aria-hidden="true">
    <span className="tips-insight-grid" />
    <span className="tips-insight-scan" />

    {type === 'speak' && (
      <div className="tips-practice-motion tips-practice-motion--speak">
        <span className="tips-speak-bubble tips-speak-bubble--one"><span lang="fr">Bonjour…</span><small lang="en">Hello…</small></span>
        <span className="tips-speak-bubble tips-speak-bubble--two"><Icon /></span>
        <VoiceBars />
      </div>
    )}

    {type === 'scenes' && (
      <div className="tips-practice-motion tips-practice-motion--scenes">
        <svg viewBox="0 0 260 90" preserveAspectRatio="none" focusable="false">
          <path d="M20 68 C62 10 104 82 145 37 C177 2 213 28 240 12" pathLength="1" />
          <circle cx="20" cy="68" r="4" />
          <circle cx="145" cy="37" r="4" />
          <circle cx="240" cy="12" r="5" />
        </svg>
        <span className="tips-scenes-pin"><Icon /></span>
        <i className="tips-scenes-packet" />
      </div>
    )}

    {type === 'vocabulary' && (
      <div className="tips-practice-motion tips-practice-motion--vocabulary">
        <span className="tips-word-chip tips-word-chip--one"><span lang="fr">bonjour</span><small lang="en">hello</small></span>
        <span className="tips-word-chip tips-word-chip--two"><span lang="fr">besoin</span><small lang="en">need</small></span>
        <span className="tips-word-chip tips-word-chip--three"><span lang="fr">encore</span><small lang="en">again</small></span>
        <span className="tips-word-core"><Icon /></span>
      </div>
    )}

    {type === 'voice' && (
      <div className="tips-practice-motion tips-practice-motion--voice">
        <span className="tips-voice-ring tips-voice-ring--one" />
        <span className="tips-voice-ring tips-voice-ring--two" />
        <span className="tips-voice-core"><Icon /></span>
        <VoiceBars />
        <LuVolume2 className="tips-voice-speaker" />
      </div>
    )}

    {type === 'pleasure' && (
      <div className="tips-practice-motion tips-practice-motion--pleasure">
        <span className="tips-pleasure-core"><Icon /></span>
        <span className="tips-pleasure-heart"><LuHeart /></span>
        <span className="tips-pleasure-spark"><LuSparkles /></span>
        <span className="tips-pleasure-equalizer">
          {[12, 24, 18, 31, 15, 26, 10].map((height, index) => (
            <i key={`${height}-${index}`} style={{ '--equalizer-height': `${height}px` }} />
          ))}
        </span>
      </div>
    )}

    {type === 'routine' && (
      <div className="tips-practice-motion tips-practice-motion--routine">
        <span className="tips-routine-orbit" />
        <span className="tips-routine-core"><Icon /><b>5</b><small>min</small></span>
        <span className="tips-routine-days">
          {Array.from({ length: 7 }, (_, index) => <i key={index} style={{ '--day-index': index }} />)}
        </span>
      </div>
    )}

    <span className="tips-practice-visual__live">
      <i />
      <span lang="fr">micro-pratique</span>
      <small lang="en">micro-practice</small>
    </span>
  </div>
)

export { PracticeMotion, PrincipleMotion }
